import { createCustomEnum } from "./customEnum";

const ClosureReasons = createCustomEnum({
	AgentRequest: {
		value: "agent_request",
		name: "agent_request",
		displayName: "Agent Request",
	},
	ApplicationDenied: {
		value: "application_denied",
		name: "application_denied",
		displayName: "Application Denied",
	},
	ClosedBusiness: {
		value: "closed_business",
		name: "closed_business",
		displayName: "Closed Business",
	},
	Collections: {
		value: "collections",
		name: "collections",
		displayName: "Collections",
	},
	EquipmentTechnology: {
		value: "equipment_technology",
		name: "equipment_technology",
		displayName: "Equipment/Technology",
	},
	Lease: {
		value: "lease",
		name: "lease",
		displayName: "Lease",
	},
	NewAuroraAccount: {
		value: "new_aurora_account",
		name: "new_aurora_account",
		displayName: "New Aurora Account",
	},
	NoLongerAcceptingCc: {
		value: "no_longer_accepting_cc",
		name: "no_longer_accepting_cc",
		displayName: "No Longer Accepting CC",
	},
	OutOfBusiness: {
		value: "out_of_business",
		name: "out_of_business",
		displayName: "Out of Business",
	},
	Pricing: {
		value: "pricing",
		name: "pricing",
		displayName: "Pricing",
	},
	RiskAchRejects: {
		value: "risk_ach_rejects",
		name: "risk_ach_rejects",
		displayName: "Risk-ACH Rejects",
	},
	RiskExcessChargebacks: {
		value: "risk_excess_chargebacks",
		name: "risk_excess_chargebacks",
		displayName: "Risk-Excess Chrgbks",
	},
	RiskExcessCreditRisk: {
		value: "risk_excess_credit_risk",
		name: "risk_excess_credit_risk",
		displayName: "Risk-Excess Credit Risk",
	},
	RiskFraud: {
		value: "risk_fraud",
		name: "risk_fraud",
		displayName: "Risk-Fraud",
	},
	RiskHighRiskProhibited: {
		value: "risk_high_risk_prohibited",
		name: "risk_high_risk_prohibited",
		displayName: "Risk-High Risk/Prohibited",
	},
	RiskMatchListing: {
		value: "risk_match_listing",
		name: "risk_match_listing",
		displayName: "Risk-MATCH Listing",
	},
	RiskUnderwriting: {
		value: "risk_underwriting",
		name: "risk_underwriting",
		displayName: "Risk-Underwriting",
	},
	SalesIssue: {
		value: "sales_issue",
		name: "sales_issue",
		displayName: "Sales Issue",
	},
	Service: {
		value: "service",
		name: "service",
		displayName: "Service",
	},
	SoldBusiness: {
		value: "sold_business",
		name: "sold_business",
		displayName: "Sold Business",
	},
});

export default ClosureReasons;
